import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from '../app/auth/login/login.component';
import { ForgotPasswordComponent } from '../app/auth/forgot-password/forgot-password.component';
import { AuthGuardComponent } from '../app/service/auth.guard.component';
import { ResetPasswordComponent } from '../app/auth/reset-password/reset-password.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent, resolve: [AuthGuardComponent] },
  { path: 'forgot-password', component: ForgotPasswordComponent, resolve: [AuthGuardComponent] },
  { path: 'ResetPassword/:id', component: ResetPasswordComponent, resolve: [AuthGuardComponent] },
  { path: 'home', loadChildren: './dashboard/dashboard.module#DashboardModule' },
  { path: '', loadChildren: './dashboard/dashboard.module#DashboardModule' },
  //{ path: '', redirectTo: '/login', pathMatch: 'full' },
];
@NgModule({
   declarations: [
    
  ],
  imports: [RouterModule.forRoot(routes)],
  exports: [
    RouterModule
  ],
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/app-routing.module.ts